var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.EndTransitionPopup = function() {
    EHDI.aka.Container.call(this);

    var _overlay, 
        _container,
        _message,
        _nextButton; 
    
    this.popUpWillAppear = function() {
        _overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
        _overlay.anchor.set(0.5, 0.5);
        _overlay.alpha = 0;
        
        this.addChild(_overlay);
        _overlay.interactive = true;
        
        _container = new EHDI.aka.Sprite( EHDI.Assets.images["con_achievement"] );
        _container.anchor.set(0.5, 0.5);
        this.addChild(_container);
        
        _message = new EHDI.aka.PixiText( EHDI.localization.strings["endmessage"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["endmessage"].size, 
            align: 'center',
            wordWrap: true,
            wordWrapWidth: _container.width * 0.85,
            fill: '#000000'
        });
        _message.anchor.set(0.5, 0.5);
        _container.addChild(_message);
    }
    
    this.popUpDidAppear = function() {
        _overlay.alpha = 0.5;
        _nextButton = new EHDI.displays.Button(EHDI.Assets.images["btn_continue"], null, null, null, 0.8);
        _nextButton.position.set( EHDI.screen.viewWidth * 0.425, EHDI.screen.viewHeight * 0.375 );
        _container.addChild(_nextButton);
        _nextButton.setOnClickFunction(onNextButton);
    }
    
    var onNextButton = function() {
        EHDI.GAME.soundManager.stopAllSFX();
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.popAllPopUps(true);
        EHDI.GAME.soundManager.resumeBGM();
        EHDI.GAME.sceneManager.changeScene(new EHDI.scene.PostGameScene(), true);
    }
    
}

EHDI.popup.EndTransitionPopup.prototype = Object.create(EHDI.aka.Container.prototype);